import styled from "styled-components";

export const Img=styled.img`
    width:70%;
    height:100%;
`;